import React from 'react';
var AnalyticsContext = React.createContext({
    fireAnalyticsEvent: function (_event) { return null; },
});
export default AnalyticsContext;
//# sourceMappingURL=analyticsContext.js.map